import { PrintComponent } from './main/patient/print/print.component';
import { AuthenticatedGuard, NotAuthenticatedGuard } from './core/guards/authentication.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./main/main.module').then(m => m.MainModule),
    canActivate: [AuthenticatedGuard]
  },
  {
    path: '',
    loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule),
    canActivate: [NotAuthenticatedGuard]
  },
  {
    path: 'print',
    outlet: 'print',
    component: PrintComponent,
    canActivate: [AuthenticatedGuard]
  },
  {
    path: '**',
    redirectTo: '/'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
